import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  ticketsBoxList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '10px '
  },
  ticketsBoxList1Columns: {},
  ticketsBoxList2Columns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
  },
  ticketsBoxList3Columns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'
  },
  ticketsListWrapper: {
    // position: 'relative',
    display: 'flex',
    // height: '100%',
    flexDirection: 'column'
  },
  ticketsList: {
    flex: 1,
    maxHeight: '100%',
    overflow: 'hidden',
    overflowY: 'scroll',
    ...theme.scrollbarStyles
    // borderTop: '2px solid rgba(0, 0, 0, 0.12)'
  },
  reportTableContainer: {
    maxHeight: '100%',
    overflow: 'auto',
    ...theme.scrollbarStyles,
    '& table': {
      tableLayout: 'fixed',
      width: '100%'
    }
  },
  reportTableHead: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_50.main,
    '& .MuiTableCell-stickyHeader': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_50.main,
      fontWeight: 600,
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      opacity: 1,
      '&:hover': {
        opacity: 1,
        backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_50.main
      }
    }
  },
  reportHeaderCell: {
    whiteSpace: 'nowrap',
    fontSize: '13px',
    padding: '8px 12px',
    cursor: 'pointer',
    userSelect: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? theme.palette.dark_stroke.main : theme.palette.gray_stroke.main}`,
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_50.main,
    transition: 'color 0.2s ease',
    opacity: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
      padding: '6px 8px'
    },
    '&:hover': {
      opacity: 1,
      color: theme.palette.type === 'dark' ? theme.palette.dark_25?.main || '#ffffff' : theme.palette.gray_300?.main || '#4a5568'
    }
  },
  reportEmptyCell: {
    textAlign: 'center'
  },

  ticketsListHeader: {
    color: 'rgb(67, 83, 105)',
    zIndex: 2,
    backgroundColor: 'white',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  ticketsCount: {
    fontWeight: 'normal',
    color: 'rgb(104, 121, 146)',
    marginLeft: '8px',
    fontSize: '14px'
  },

  noTicketsText: {
    textAlign: 'center',
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    fontSize: '14px',
    lineHeight: '1.4'
  },

  noTicketsTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '16px',
    fontWeight: '600',
    color: theme.palette.blue_300.main
  },

  noTicketsDiv: {
    display: 'flex',
    height: '100px',
    margin: 40,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter, sans-serif'
  }
}))
